// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-container {
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.actions {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
.actions button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
}

.children-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.child-card {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.child-card .child-info {
  display: flex;
  align-items: center;
  flex: 1;
}
.child-card .child-info .child-details {
  margin-left: 16px;
}
.child-card .child-info .child-details h2 {
  margin: 0 0 8px 0;
  font-size: 1.2rem;
  color: #333;
}
.child-card .child-info .child-details p {
  margin: 4px 0;
  color: #666;
}
.child-card .safety-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.child-card .safety-features .safety-feature {
  display: flex;
  align-items: center;
  background-color: #f0f7ff;
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 0.8rem;
  color: #3880ff;
}
.child-card .safety-features .safety-feature mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.child-card .child-actions {
  display: flex;
  gap: 8px;
}

@media (max-width: 600px) {
  .child-card {
    flex-direction: column;
    align-items: flex-start;
  }
  .child-card .child-info {
    margin-bottom: 16px;
  }
  .child-card .child-actions {
    align-self: flex-end;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/profile/child-list/child-list.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,OAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAEM;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;AAAR;AAGM;EACE,aAAA;EACA,WAAA;AADR;AAME;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAJJ;AAMI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAJN;AAMM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAJR;AASE;EACE,aAAA;EACA,QAAA;AAPJ;;AAWA;EACE;IACE,sBAAA;IACA,uBAAA;EARF;EAUE;IACE,mBAAA;EARJ;EAWE;IACE,oBAAA;EATJ;AACF;AACA,4oGAA4oG","sourcesContent":[".content-container {\n  padding: 16px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 24px;\n  \n  button {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n  }\n}\n\n.children-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.child-card {\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  .child-info {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    \n    .child-details {\n      margin-left: 16px;\n      \n      h2 {\n        margin: 0 0 8px 0;\n        font-size: 1.2rem;\n        color: #333;\n      }\n      \n      p {\n        margin: 4px 0;\n        color: #666;\n      }\n    }\n  }\n  \n  .safety-features {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 8px;\n    \n    .safety-feature {\n      display: flex;\n      align-items: center;\n      background-color: #f0f7ff;\n      border-radius: 16px;\n      padding: 4px 8px;\n      font-size: 0.8rem;\n      color: #3880ff;\n      \n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        margin-right: 4px;\n      }\n    }\n  }\n  \n  .child-actions {\n    display: flex;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 600px) {\n  .child-card {\n    flex-direction: column;\n    align-items: flex-start;\n    \n    .child-info {\n      margin-bottom: 16px;\n    }\n    \n    .child-actions {\n      align-self: flex-end;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
